<ng-container *ngIf="user">
  <app-toolbar [user]="user" [title]="title" [back]="true" [destination]="destination"></app-toolbar>
</ng-container>

<div class="container">
  <mat-card class="mat-elevation-z5">
    <div style="vertical-align: middle">
      <h1>Registra un nuovo paziente</h1>
    </div>
    <mat-card-content fxLayout="column">

      <form class="form" [formGroup]="registrationForm" (ngSubmit)="onSubmit(registrationForm.value)">

        <mat-form-field appearance="outline">
          <mat-label>Inserisci l'email del paziente</mat-label>
          <input class="email-input" matInput placeholder="Email" formControlName="email" (focusin)="notFocused=false" (focusout)="notFocused=true">
          <ng-container *ngIf="registrationForm.get('email').hasError('email') && notFocused">
            <div style="padding-top:15px">
            <span class="error">
             Inserisci un'email valida
            </span>
            </div>
          </ng-container>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Inserisci il nome del paziente</mat-label>
          <input matInput placeholder="Nome" formControlName="name" (focusin)="notFocused=false" (focusout)="notFocused=true">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Inserisci il cognome del paziente</mat-label>
          <input matInput placeholder="Cognome" formControlName="surname" (focusin)="notFocused=false" (focusout)="notFocused=true">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Inserisci il codice fiscale del paziente</mat-label>
          <input matInput placeholder="Codice fiscale" formControlName="ssn" (focusin)="notFocused=false" (focusout)="notFocused=true">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Inserisci la data di nascita</mat-label>
          <input matInput [matDatepicker]="picker" (dateChange)="setDate($event)">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <!--<mat-form-field appearance="outline">
          <mat-label>Inserisci il tuo Comune di nascita</mat-label>
          <input matInput placeholder="Città" formControlName="birthPlace" (focusin)="notFocused=false" (focusout)="notFocused=true">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Inserisci la Provincia del tuo Comune di nascita</mat-label>
          <input matInput placeholder="Provincia" formControlName="province" (focusin)="notFocused=false" (focusout)="notFocused=true">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Inserisci il CAP del tuo Comune di nascita</mat-label>
          <input matInput placeholder="CAP" formControlName="cap" (focusin)="notFocused=false" (focusout)="notFocused=true">
        </mat-form-field>-->

        <!--<mat-form-field appearance="outline">
          <mat-label>Inserisci il numero di telefono del paziente</mat-label>
          <input matInput placeholder="Numero di telefono" formControlName="phoneNumber" (focusin)="notFocused=false" (focusout)="notFocused=true">
        </mat-form-field>-->

        <!--<mat-form-field appearance="outline">
          <mat-label>Inserisci il peso del paziente in kg</mat-label>
          <input matInput type="number" placeholder="Peso" formControlName="weight" (focusin)="notFocused=false" (focusout)="notFocused=true">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Inserisci l'altezza del paziente in cm</mat-label>
          <input matInput type="number" placeholder="Altezza" formControlName="height" (focusin)="notFocused=false" (focusout)="notFocused=true">
        </mat-form-field>-->

        <mat-form-field appearance="outline">
          <mat-label>Inserisci la patologia del paziente</mat-label>
          <mat-select required>
            <mat-option *ngFor="let value of pathologies" [value]="value"
                        (onSelectionChange)="selectResult($event, value)">
              {{value}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!--<ng-container *ngIf="otherPathology">
        <mat-form-field appearance="outline">
          <mat-label>Specifica la patologia del paziente</mat-label>
          <input matInput placeholder="Patologia" formControlName="pathology" (focusin)="notFocused=false" (focusout)="notFocused=true">
        </mat-form-field>
        </ng-container>-->

        <!--<mat-form-field appearance="outline">
          <mat-label>Scegli il gruppo per il paziente</mat-label>
          <mat-select required>
            <mat-option *ngFor="let value of choices" [value]="value"
                        (onSelectionChange)="selectChoice($event, value)">
              {{value}}
            </mat-option>
          </mat-select>
        </mat-form-field>-->

        <ng-container *ngIf="submitted">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-container>

        <ng-container *ngIf="!show">
          <div style="padding-top: 10px">
          <button mat-raised-button type="submit" color="primary"
                  [disabled]="!registrationForm.valid">Registra</button>
          </div>
        </ng-container>

      </form>

    </mat-card-content>
  </mat-card>
</div>
